import Alert from '@mui/material/Alert';
import { useAudienceInsights } from '../../context/audienceInsights.ts';

export function InsightsWarning() {
  const { isDisabled, disabledMessage } = useAudienceInsights();

  if (!isDisabled || !disabledMessage) {
    return null;
  }

  return (
    <Alert severity="warning" data-test="audience-insights-disabled-alert">
      {disabledMessage}
    </Alert>
  );
}
